import { getRequestDatetimeParams, getIntervalDatetimeParams } from '@/utils/date';
import isNil from 'lodash/isNil';

export default {
  props: {
    active: Boolean,
  },
  computed: {
    /**
     * [commonParams 공통으로 사용할 params]
     * @author {Yang}
     * @return {[type]} [objId - 트리 objId, logStartDatetime - 로그에 보낼 startDatetime, startDatetime - 공통start time, endDatetime -공통 endtime]
     */
    commonParams() {
      const params = {
        objId: this.selectedNode.obj.objId,
      };
      if (isNil(this.plotLineDatetime)) {
        const date = new Date().getTime();
        params.endDatetime = getRequestDatetimeParams(date);
        params.logStartDatetime = getIntervalDatetimeParams(date, 'hour', 24);
        params.startDatetime = getIntervalDatetimeParams(date, 'minute', 15);
      } else {
        params.endDatetime = getRequestDatetimeParams(this.plotLineDatetime);
        params.logStartDatetime = getIntervalDatetimeParams(this.plotLineDatetime, 'hour', 24);
        params.startDatetime = getIntervalDatetimeParams(this.plotLineDatetime, 'minute', 15);
      }
      return params;
    },
    selectedNode() {
      return this.$store.getters.selectedNode;
    },
    plotLineDatetime() {
      return this.$store.getters.plotLineDatetime;
    },
    /**
     * [e2eCommonParams e2e에서 공통으로 사용할 params]
     * @author {Yang}
     * @return {[type]} [serviceId - 트리 serviceId, transactionId - 트리 transactionId, rscKey - 트리 rscKey, logStartDatetime - 로그에 보낼 startDatetime, startDatetime - 공통start time, endDatetime -공통 endtime]
     */
    e2eCommonParams() {
      const params = {
        serviceId: this.selectedNode.serviceId,
        transactionId: this.selectedNode.transactionId,
        rscKey: this.selectedNode.rscKey,
      };
      if (isNil(this.plotLineDatetime)) {
        const date = new Date().getTime();
        params.endDatetime = getRequestDatetimeParams(date);
        params.logStartDatetime = getIntervalDatetimeParams(date, 'hour', 24);
        params.startDatetime = getIntervalDatetimeParams(date, 'minute', 15);
      } else {
        params.endDatetime = getRequestDatetimeParams(this.plotLineDatetime);
        params.logStartDatetime = getIntervalDatetimeParams(this.plotLineDatetime, 'hour', 24);
        params.startDatetime = getIntervalDatetimeParams(this.plotLineDatetime, 'minute', 15);
      }
      return params;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/performance/analysis-table.js